export const ALLOWED_STORE_NAMES = ['RESMED', 'RESMED_US', 'RESMED_EU', 'RESMED_AP', 'RESMED_CA'];

export const ALLOWED_REDIRECT_ORIGINS = [
  'http://localhost:3000',
  'https://onlinestore.resmed.com',
  'https://uat-onlinestore.resmed.com',
  'https://qa2-ros-ep-web-ui.priv.devx-eks-stg.dht.live',
  'https://alpha-ros-ep-web-ui.priv.devx-eks-stg.dht.live',
  'https://dev-amr-ros-team-ros-ep-web-ui.priv.amr-nonprod.devx-eks-stg.dht.live',
  'https://dev-ros-ep-web-ui.priv.devx-eks-stg.dht.live',
  'https://sbx-dev1-ros-ep-web-ui.priv.devx-eks-stg.dht.live',
  'https://qa-ros-ep-web-ui.devx-eks-stg.dht.live',
  'https://dev-ros-ep-web-ui.priv.devx-eks-stg.dht.live',
  'https://qa-ros-ep-web-ui.priv.devx-eks-stg.dht.live'
];

export function getValidatedStoreName(storeName) {
  const normalizedStoreName = (storeName || '').trim();
  if (!normalizedStoreName) {
    throw new Error('StoreName missing');
  }
  if (!ALLOWED_STORE_NAMES.includes(normalizedStoreName)) {
    throw new Error('Invalid store name');
  }
  return normalizedStoreName;
}

export function validateStoreName(storeName) {
  getValidatedStoreName(storeName);
  return true;
}

export function sanitizeStoreNameForPath(storeName) {
  return encodeURIComponent(getValidatedStoreName(storeName));
}

export function validateRedirectURI(origin = window.location.origin) {
  if (!ALLOWED_REDIRECT_ORIGINS.includes(origin)) {
    throw new Error('Unauthorized redirect URI');
  }
  return true;
}
